import React from "react";

import svg from "../../assets/images/icons/Form Controls/Color Picker.svg";

export const ColorPickerIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Color Picker"}
    />
);
